import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 28 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 24\" id=\"icon-arrow-left\"><path d=\"M10.4 0l1.8 1.4L14 2.8l-1.8 2-4.4 5H28V14H7.6l4.6 5.4 1.8 2-1.8 1.2-1.8 1.4L0 12 10.4 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol